import { render } from "./Share.vue?vue&type=template&id=43d71123"
const script = {}

import "./Share.vue?vue&type=style&index=0&id=43d71123&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__